<template>
  <v-container class="flex" fill-height>
    <v-layout row align-center justify-space-around wrap >     
      <password-policy-check ref="pwdPolicy" :newPassword="newPassword" />
      <v-flex xl4 md6 sm10 xs11>
        <v-container @keydown.enter="changePassword" style="position: relative;top: 13%;" class="flex text-xs-center grey lighten-4">
          <v-card flat>
            <v-card-title primary-title>
              <h4>{{ $t("ChangePassword.Title") }}</h4>
            </v-card-title>
            <v-form class="px-1">                            
              <v-text-field v-model="oldPassword" ref="Password" browser-autocomplete="current-password" prepend-icon="mdi-lock" :append-outer-icon="showOldPassword?'mdi-eye-off':'mdi-eye'"  @click:append-outer="showOldPassword = !showOldPassword" name="Password" :label="$t('ChangePassword.OldPassword')" :type="showOldPassword?'text':'password'"  :rules="[ruleRequired]"></v-text-field>
              <v-text-field v-model="newPassword" ref="NewPassword" browser-autocomplete="new-password" prepend-icon="mdi-lock" name="NewPassword" :append-outer-icon="showNewPassword?'mdi-eye-off':'mdi-eye'"  @click:append-outer="showNewPassword = !showNewPassword" :label="$t('ChangePassword.NewPassword')" :type="showNewPassword?'text':'password'"   :rules="[ruleRequired]"></v-text-field>
              <v-text-field  v-model="confirmNewPassword" ref="confirmPassword" prepend-icon="mdi-lock" name="ConfirmNewPassword" :append-outer-icon="showConfirmNewPassword?'mdi-eye-off':'mdi-eye'"  @click:append-outer="showConfirmNewPassword = !showConfirmNewPassword" :label="$t('CreatePassword.ConfirmNewPassword')"  :type="showConfirmNewPassword?'text':'password'"  :rules="[ruleRequired, rulePasswordMatch]" :validate-on-blur="true"></v-text-field>              
              <v-card-actions>
                <v-btn @click="changePassword" :disabled="!isValid || loa" color="primary" large block >{{ $t("ChangePassword.Modify") }}</v-btn>
              </v-card-actions>              
              {{changePwdStatus.length > 0? `${$t(`ChangePassword.${changePwdStatus}`)} : ${ errorMsg }`:''}}
            </v-form>
          </v-card>
        </v-container>
      </v-flex>                  
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import * as rules from '@/utils/validationRules'
import PasswordPolicyCheck from "@/components/shared/PasswordPolicyCheck.vue"

@Component({
  name: 'ChangePassword',  
  components:{PasswordPolicyCheck}
})
export default class ChangePassword extends Vue {
  
  oldPassword = ''
  newPassword = ''   
  confirmNewPassword = ''   
  dirtyPwd = false
  dirtyOldPwd = false  
  dirtyConfirmPwd = false    

  showOldPassword = false
  showNewPassword = false
  showConfirmNewPassword = false  
    
  private loading = false

  errorMsg = ""

  get changePwdStatus(){
      return this.$store.myGetters.changePwdStatus
  }
  
  @Watch("dirtyPwd")
  onDityPwdChange(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.Password.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyOldPwd")
  onDityOldPwdChange(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.NewPassword.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyConfirmPwd")
  dirtyConfirmPwdChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.confirmPassword.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  mounted() {    
    this.hackToSolveAutoFillIssue()          
    this.$store.myActions.AUTH_CHANGEPASSWORD_RESET_STATUS()
    this.$vuetify.theme.primary = '#4066aa'
    this.$vuetify.theme.secondary = '#ec7404'     
  }
  
  hackToSolveAutoFillIssue(){
    let times = 0;
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyOldPwd && this.dirtyPwd) || times === 30) {
        clearInterval(interval)
      }
      else{               
        this.dirtyPwd = !!document.querySelector('input[name="Password"]:-webkit-autofill')        
        this.dirtyOldPwd = !!document.querySelector('input[name="NewPassword"]:-webkit-autofill')
        this.dirtyConfirmPwd = !!document.querySelector('input[name="ConfirmNewPassword"]:-webkit-autofill')
      }
    }, 100)
  }

  rulePasswordMatch(v:string) {    
    return rules.rulePasswordMatch(v,this.newPassword)
  }
  

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  get isValid(){
    return this.rulePasswordMatch(this.confirmNewPassword) 
        && this.$refs.pwdPolicy
        //@ts-ignore
        && this.$refs.pwdPolicy.isValid
  }

  changePassword() {       
    if(this.isValid){
      const {oldPassword, newPassword} = this    
      this.loading = true  
      this.$store.myActions.AUTH_CHANGEPASSWORD_REQUEST({ oldPassword, newPassword }).then(() => {                    
        this.$router.push("/")
      })
      .catch(error => {        
        this.errorMsg = error?.message ?? error
      })
      .finally(()=>{
        this.loading = false
      })
    }    
  }
}

</script>

<style>
</style>